import { Checkbox } from "@/components/ui/checkbox";

// Option bei Rechnungserstellung ohne CRM-Mail: direkt fertigstellen (sevDesk „Offen“) oder nur als Entwurf anlegen
export const RechnungFertigstellenOption = ({ checked, onChange, disabled, testId = "rechnung-fertigstellen-checkbox" }) => (
  <label className={`flex items-start gap-3 p-3 rounded-md border border-slate-200 ${disabled ? "opacity-70 cursor-not-allowed" : "cursor-pointer hover:bg-slate-50"} transition-colors`}>
    <Checkbox checked={checked} onCheckedChange={(v) => onChange(!!v)} disabled={disabled} className="mt-0.5" data-testid={testId} />
    <span className="text-sm">
      <span className="font-medium text-slate-900">Rechnung direkt fertigstellen</span>
      <span className="block text-xs text-slate-500 mt-0.5" data-testid={`${testId}-hint`}>
        {checked
          ? "Die Rechnung wird in sevDesk fertiggestellt (Status „Offen“, finale Nummer, buchbar) – es wird keine E-Mail versendet."
          : "Die Rechnung bleibt in sevDesk ein Entwurf und kann später mit „Rechnung fertigstellen“ abgeschlossen werden."}
      </span>
    </span>
  </label>
);
